/* SYNCED from shotbook-landing/src/components/ui/ApertureMark.tsx — не править руками, запускать npm run sync:ds */
/**
 * Знак ShotBook — диафрагма объектива. Перенесён из старого лендинга
 * (public/new_logo.svg), исходный цвет #193e66 заменён на currentColor,
 * чтобы знак красился токеном темы.
 *
 * В логотипе он стоит вместо буквы «O»: SH⊙TBOOK.
 */
export function ApertureMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 70.86 68.4"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M19.26,3.46S2.93,11.75,1.13,26.52c0,0,11.56,11.49,21.8,14.06,0,0-9.22-12.5-3.67-37.12Z" />
      <path d="M22.58,2.02s15.55-5.39,27.19,1.45c0,0-21.68,13.4-27.93,24.34,0,0-3.2-13.28.74-25.79Z" />
      <path d="M33.07,19.44s13.71-13.77,20.92-14.53c0,0,14.42,6.68,16.53,25.08,0,0-15.18-11.78-37.45-10.55Z" />
      <path d="M45.85,23.39s13.36.47,24.67,9.96c0,0,3.22,13.01-10.02,25.2,0,0-5.68-27.63-14.65-35.16Z" />
      <path d="M49.77,34.84s-1.04,15.31-16.7,33.44c0,0,15.45,1.72,25.28-7.81,0,0-2-18.13-8.58-25.63Z" />
      <path d="M29.91,67.19s-7.66,2.81-22.35-12.81c0,0,13.91,2.34,35.79-9.06,0,0-1.09,7.19-13.44,21.88Z" />
      <path d="M.47,28.7s-2.76,14.43,5.16,22.92c0,0,14.34,1.81,27.45-4.75,0,0-25.8-7.5-32.6-18.17Z" />
    </svg>
  );
}
